// @ts-nocheck

import type { Action } from '../actions/review';
import { QRActionTypes } from '../types/actions/qr';

type State = { scan: string | null };

export const miscInitialState: State = { scan: '' };

export default (state: State = miscInitialState, action: Action): State => {
  switch (action.type) {
    case QRActionTypes.SET_QR_SCAN_RESULT: {
      const {
        payload: { scan },
      } = action;
      return {
        ...state,
        scan,
      };
    }

    case QRActionTypes.RESET_QR_SCAN_RESULT: {
      return {
        ...state,
        scan: '',
      };
    }
    default:
      return state;
  }
};
